import { permissionManifest } from '@/permissions/permission-manifest';

const SYSTEM_ADMIN_ROLE_CODE = 'system_admin';

/** 前端约定：系统管理员默认拥有 Manifest 中的全部权限（无需后端预配） */
export function normalizeAuthz(
  authz: API.AdminUserAuthzResponse | null | undefined,
): API.AdminUserAuthzResponse | undefined {
  if (!authz) return undefined;
  const isSystemAdmin = authz.roles?.some(
    (r) => r.code === SYSTEM_ADMIN_ROLE_CODE,
  );
  if (!isSystemAdmin) return authz;
  const allKeys = permissionManifest.map((p) => p.perm_key);
  const mergedKeys = Array.from(
    new Set([...(authz.permission_keys ?? []), ...allKeys]),
  );
  return {
    ...authz,
    permission_keys: mergedKeys,
  };
}
